interface CheckIconProps {
  size?: number;
  className?: string;
}

const CheckIcon = ({ size = 16, className = '' }: CheckIconProps) => {
  return (
    <span className={className}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M13.3333 4L6 11.3333L2.66667 8'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
};

export default CheckIcon;
